import { Component } from '@angular/core';
import {FormBuilder, FormGroup, ReactiveFormsModule} from "@angular/forms";
import {ActivatedRoute, Router} from "@angular/router";
import {SwitchBoard} from "../services/SwitchBoard";
import {LoadingService} from "../services/LoadingService";
import {LoginForm} from "../forms/login.form";
import {ToastService} from "../services/Toast.service";
import {LogoService} from "../services/LogoService";
import {LOGIN_LOGO_CSS, TOAST_TYPE} from "../constants/Tpiq.constants";
import {LoginService} from "../services/Login.service";
import {ForgotPassword} from "../forms/ForgotPassword.form";
import {Session} from "../services/Session";
import {LoginModel} from "../models/Login.model";
import {UrlService} from "../services/UrlService";
import {TaxPlanningService} from "../tpiq-services/tax-planning.service";
import {FeatureFlagService} from "../tpiq-services/feature-flag.service";
import {CommonModule} from "@angular/common";
import {BrowserModule} from "@angular/platform-browser";

declare let jQuery: any;
declare let _: any;

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss'
})
export class LoginComponent {
  loginForm: FormGroup;
  forgotPasswordForm: FormGroup;
  success: any;
  error: any;
  status = null;
  message = '';
  showLoginPage = true;
  forgotPwdStatus = false;
  showOtpPage = false;
  showForgotPasswordPage = false;
  fpStatus: any;
  fpMessage = '';
  resetPasswordToken = '';
  routeSub: any;
  sub: any;
  logoBg: any;
  logoSub: any;
  loginData: any;
  userId: any;
  org: any;
  token: any;
  delegateParams: any;
  isLoginByToken = false;
  logosObj: any;
  hasLoginBackground = false;
  orgCSS: any = LOGIN_LOGO_CSS;
   reveal: any = {
    showPopup: false,
  };

  active = true;
  taxPlanningTerms: any;

  constructor(private fb: FormBuilder, private _router: Router,  private switchBoard: SwitchBoard, private loginService: LoginService,
              private _loginForm: LoginForm, private loadingService: LoadingService,private _forgotPasswordForm: ForgotPassword,
              private _route: ActivatedRoute, private _toastService: ToastService,
              private logoService: LogoService, private taxPlanningService: TaxPlanningService,
              private featureFlagService: FeatureFlagService) {
    const base = this;
    this.routeSub = this._route.params.subscribe(params => {
      this.resetPasswordToken = params.resetPasswordToken;
    });

    this.sub = this._route.queryParams.subscribe(params => {
      if (params.token){
        this.isLoginByToken = true;
        this.switchBoard.onLoginByToken.next(true);  // Broadcast token login
        this.delegateParams = _.cloneDeep(params);
        this.loginByToken();

      }
      if (params.ssotoken){
        Session.destroy();
        this.delegateParams = _.cloneDeep(params);
        this.loginBySSOToken();
      }
    });
    this.org = this.logoService.getOrg();
    this.loginForm = fb.group(_loginForm.getForm());
    this.forgotPasswordForm = fb.group(_forgotPasswordForm.getForm());

    this.switchBoard.onLogosReady.subscribe(logoObj => {
      this.logosObj = logoObj;
      this.hasLoginBackground = logoObj.loginBackgroundImg ? true : false;
      if (logoObj.loginLogoUrl){
        base.logoBg = {
          background: 'url("' + logoObj.loginLogoUrl + '") center center no-repeat',
          'background-size': 'contain'
        };
        const cssArray = this.orgCSS[this.org];
        if (cssArray) {
          _.each(cssArray, function(obj) {
            base.logoBg[obj.style] = obj.value;
          });
        }
      } else if (this.org === 'stag-app' || this.org === 'app') {
        let tpiqLogo = 'https://static.taxplaniq.com/test-taxplaniq/new_tpiq_logo.png';
        base.logoBg = {
          background: 'url("' + tpiqLogo + '") center center no-repeat',
          'background-size': 'contain'
        };
      }
    });
    this.validateLoginAndRedirect();
  }

  submit($event) {
    this.loadingService.triggerLoadingEvent(true);
    $event && $event.preventDefault();
    const data = this._loginForm.getData(this.loginForm);
    data.username = data.id;
    this.loginData = data;
    this.loginService.login(data as LoginModel, 'Wall')
      .subscribe(success  => {this.showMessage(true, success); }, error =>  this.showMessage(false, error));
  }

  initSleek() {
    window['$sleek']=[];
    window['SLEEK_PRODUCT_ID']=771146479;
    (() => {
      const d = document;
      const s = d.createElement("script");
      s.src = "https://client.sleekplan.com/sdk/e.js";
      s.async = Boolean(1);
      d.getElementsByTagName("head")[0].appendChild(s);
    })();
  }

  addSessionData(obj, loginByTokenData?) {
    Session.put('userId', obj.userId);
    Session.setToken(obj.token);
    Session.setRefreshToken(obj.refreshToken);
    Session.setOrg(obj.org);
    this.userId = obj.userId;
    this.org = obj.org;
    this.token = obj.token;
    const orgName = window.location.href.split('/')[2].split('.')[0];
    if (orgName === 'stag-app' || orgName === 'app') {
      this.handleLogos();
    }
    this.getUserSubscriptionAccessList(this.userId, this.org, loginByTokenData);
  }

  handleLogos(){
    this.logoService.getOrgLogos(this.org).subscribe(response => {
      this.logoService.setLogoUrls(response);
      this.switchBoard.onLogosReady.next(response);
      if (response.faviconUrl){
        jQuery('#favicon').attr('href', response.faviconUrl);
      }
    }, error => {
    });
  }

  closePopup() {
    this.reveal.showPopup = false; 
    this._toastService.pop(TOAST_TYPE.success, 'Email sent successfully');
    this.loginPage();
    const link = ['login'];
    this._router.navigate(link);
  }

  showMessage(status, obj) {
    if (status) {
      if (!this.isLoginByToken){
        if(!obj.isCustomer){
        //this.initSleek();
        }
      }
      this.addSessionData(obj);
    } else {
      this.showLoginError(obj);
      this.loadingService.triggerLoadingEvent(false);
    }
  }

  showLoginError(obj?){
    this.status = {};
    this.status.error = true;
    this.message = 'Username or password incorrect';
    if (obj && obj.message){
      this.message = obj.message;
    }
    this.loadingService.triggerLoadingEvent(false);
  }

  handleError(error){
    this.loadingService.triggerLoadingEvent(false);
  }

  newLogin() {
    this.active = false;
    setTimeout(() => this.active = true, 0);
  }

  changePassword($event){
    $event && $event.preventDefault();
    const data = this._forgotPasswordForm.getData(this.forgotPasswordForm);
    data.activationLink = UrlService.getBaseUrl('ACTIVATION_LINK');
    data.username = data.id;
    this.loadingService.triggerLoadingEvent(true);
    this.loginService.forgotPassword(data, this.org, 'Wall').subscribe(success => this.handleForgotPassword(true, success),
      error => this.handleForgotPassword(false, error));
  }

  handleForgotPassword(status, obj){
    this.loadingService.triggerLoadingEvent(false);
    if (status) {
      this.reveal.showPopup = true;
    } else {
      this._toastService.pop(TOAST_TYPE.error, 'Failed to reset password');
    }
  }

  checkForgotPasswordValidity(){
    if (!this.forgotPasswordForm.valid){
      return false;
    }
    return true;
  }

  checkValidity() {
    if (!this.loginForm.valid) {
      return false;
    }
    return true;
  }

  ngOnInit() {

  }

  resetPassword(){
    const resetPassword = jQuery('#resetPassword').val();
    const resetPasswordConfirmation = jQuery('#resetPasswordConfirmation').val();
    if (!resetPassword && !resetPasswordConfirmation){
      this.forgotPwdStatus = true;
      this.fpStatus = {};
      this.fpStatus.error = true;
      this.fpMessage = 'please enter passwords';
    }else if (resetPassword != resetPasswordConfirmation){
      this.forgotPwdStatus = true;
      this.fpStatus = {};
      this.fpStatus.error = true;
      this.fpMessage = 'passwords donot match';
    }else{
      let data: any;
      data.password = resetPassword;
      data.token = this.resetPasswordToken;
      this.loginService.resetPassword(data, 'Wall').subscribe(success => this.handleForgotPassword(true, success),
        error => this.handleForgotPassword(false, error));
    }
  }

  ngOnDestroy(){
    this.routeSub.unsubscribe();
    if (this.logoSub){
      this.logoSub.unsubscribe();
    }
  }

  validateLoginAndRedirect(){
    const data = localStorage.getItem('wall_rm');
    const details = JSON.parse(data);
    if (details && details.rememberMe){
      this.loadingService.triggerLoadingEvent(true);
      if (details.tk_rm_id) {
        // Legacy wall_rm format (pre-868kcbzft): replays the existing session
        // via /rememberMe. Kept as the transition path until P3.4 removes the
        // access-token inflation server-side.
        // NOTE (CodeRabbit 868kcbzft): we deliberately do NOT copy tk_rm_id
        // into sessionStorage — the /rememberMe request authenticates from the
        // existing localStorage token via Session.getToken(), so that write
        // was both a no-op (nothing reads sessionStorage['token']) and an
        // extra script-readable copy of the credential. Removed.
        this.loginService.reLogin()
          .subscribe(success  => {this.showMessage(true, success); }, error => {
            this.showMessage(false, error);
            // Scoped cleanup (CodeRabbit 868kcbzft): a failed replay only
            // invalidates remember-me state - clearing ALL of localStorage
            // erased unrelated app data. Drop the wall_rm preference and the
            // sessionStorage token residue that pre-f13bfb56 bundles wrote.
            localStorage.removeItem('wall_rm');
            sessionStorage.removeItem('token');
            this.loadingService.triggerLoadingEvent(false);
          });
      } else {
        // CU-868kcbzft Option B: the HttpOnly tpiq_session cookie IS the
        // rememberMe now - exchange it for fresh tokens. session/refresh
        // returns the exact /login response shape, so the normal success
        // continuation applies unchanged. On failure (expired/revoked
        // session) just drop the flag and show the login form.
        this.loginService.sessionRefresh()
          .subscribe(success  => {this.showMessage(true, success); }, error => {
            localStorage.removeItem('wall_rm');
            this.loadingService.triggerLoadingEvent(false);
          });
      }
    }
  }

  getUserInfo(userId, org){
    this.loginService.getUserCompanyInfo(userId, org).subscribe(data  => {
      this.updateSessionDetails(data);
    }, error => {
      this.switchBoard.onLogOut.next({});
    });
  }


  getUserSubscriptionAccessList(userId, org, loginByTokenData?) {
    this.taxPlanningService.getSubscriptionStatus(org, userId).subscribe(response => {
      let obj = {};
      obj['clientPortalAccess'] = false;
      obj['dashboardAccess'] = false;
      obj['subscriptionStatus'] = response.subscriptionStatus;
      // 868jtq1h0 follow-up: capture the raw plan name (e.g.
      // "Growth-Plan-Special-697-USD-Monthly") so the choose-platform
      // Growth-tier gate in shouldShowChoosePlatform() has a non-empty
      // value to test. Previously this was being dropped on the floor and
      // every user — including allowlisted meyergroup — fell through to
      // the legacy tax-planning landing page.
      obj['subscriptionPlan'] = response.plan || '';
      if (response.accessList && response.accessList.length > 0) {
        obj['dashboardAccess'] = response.accessList.indexOf('Dashboard') != -1;
        obj['clientPortalAccess'] = response.accessList.indexOf('Client Portal') != -1;
      }
      Session.setUserAccessInfo(obj);
      this.switchBoard.onUserAccess.next({});
      if (this.isLoginByToken) {
        this.updateDelegateSessionDetails(loginByTokenData);
      } else {
        this.getUserInfo(userId, org);
      }
    }, error =>  {
      this._toastService.pop(TOAST_TYPE.error, 'Failed to get subscription status');
    });
  }

  setupUser(user){
    if (window['$sleek']){
      /*window['$sleek'].setUser ({
        mail: user.id,
        id: user.id,
        name: `${user.first_name} ${user.last_name}`
      });*/
    }
  }

  updateSessionDetails(obj){
    this.setupUser(obj);
    Session.put('user', obj);
    Session.setCurrentCompanyCurrency('USD');
    if (this.loginData && this.loginData.rememberMe) {
      // CU-868kcbzft: wall_rm is a preference flag only - the credential is
      // the HttpOnly tpiq_session cookie (30-day TTL when rememberMe).
      localStorage.setItem('wall_rm', JSON.stringify({rememberMe: true}));
    }
    if (Session.get('user').tempPassword){
      this.loadingService.triggerLoadingEvent(false);
      this._router.navigate(['activate']);
    }else {
      if (obj.isCustomer){
        this.getTpiqClientInfo(this.org, this.userId);
        this.switchBoard.onLogin.next(Session.get('user'));
        const link = ['tax-planning/customer/dashboard'];
        this._router.navigate(link);
      } else {
        this.loadingService.triggerLoadingEvent(true);
        this.taxPlanningService.getTermsAndConditions(this.org, this.userId).subscribe(response => {
          this.loadingService.triggerLoadingEvent(false);
          this.taxPlanningTerms = response || {};
          Session.setTaxPlanOrgTerms(response);
          const accessInfo: any = Session.getUserAccessInfo();
          if (!this.taxPlanningTerms.termsAccepted) {
            this._router.navigate(['tax-planning/terms']);
            return;
          } else if (accessInfo && accessInfo.subscriptionStatus == 'Suspended'){
            this._router.navigate(['tax-planning/manage-billing']);
            return;
          } else {
            const status: any = Session.get('user').onboardingStatus;
            if ((status && status === 'Done')  || !status) {
              this.switchBoard.onLogin.next(Session.getUser('delegatedFrom'));
              this.routePostLoginHome();
            } else if (status && status !== 'Done') {
              this._router.navigate(['tpiq/onboard']);
            }
          }
        });
      }
    }
  }

  forgotPasswordPage() {
    this.showForgotPasswordPage = true;
    this.showLoginPage = false;
    this.showOtpPage = false;
  }

  loginPage() {
    this.showLoginPage = true;
    this.showForgotPasswordPage = false;
    this.showOtpPage = false;
    this.loginForm = this.fb.group(this._loginForm.getForm());
  }

  loginByToken() {
    this.loadingService.triggerLoadingEvent(true);
    Session.setToken(this.delegateParams.token);
    this.loginService.getUserInfoByToken(this.delegateParams).subscribe(success => {
      this.delegateParams.refreshToken = success.refreshToken;
      this.addSessionData(this.delegateParams, success);
      Session.put('delegatedFrom', success.delegatedUser);
    }, error => {
      this.switchBoard.onLogOut.next({});
      const message = error.message || 'Invalid Token';
      this._toastService.pop(TOAST_TYPE.error, message);
      this.loadingService.triggerLoadingEvent(false);
    });
  }

  loginBySSOToken() {
    this.loadingService.triggerLoadingEvent(true);
    this.loginService.getUserInfoBySSOToken(this.delegateParams).subscribe(success => {
      this.delegateParams.refreshToken = success.refreshToken;
      this.addSessionData(success);
    }, error => {
      this.switchBoard.onLogOut.next({});
      const message = error.message || 'Invalid Token';
      this._toastService.pop(TOAST_TYPE.error, message);
      this.loadingService.triggerLoadingEvent(false);
    });
  }

  updateDelegateSessionDetails(obj){
    const delegatedUser = Session.get('delegatedFrom');
    if (delegatedUser) {
      obj.user.isCustomer = delegatedUser.isCustomer;
    }
    Session.put('user', obj.user);
    Session.setCurrentCompanyCurrency('USD');
    if (Session.get('delegatedFrom').tempPassword){
      this.loadingService.triggerLoadingEvent(false);
      this._router.navigate(['activate']);
    }else {
      if (Session.get('delegatedFrom').isCustomer){
        this.getTpiqClientInfo(this.org, obj.delegatedUser.id);
        this.switchBoard.onLogin.next(Session.get('user'));
        const link = ['tax-planning/customer/dashboard'];
        this._router.navigate(link);
      } else {
        this.loadingService.triggerLoadingEvent(true);
        this.taxPlanningService.getTermsAndConditions(this.org, obj.delegatedUser.id).subscribe(response => {
          this.loadingService.triggerLoadingEvent(false);
          this.taxPlanningTerms = response || {};
          Session.setTaxPlanOrgTerms(response);
          const accessInfo: any = Session.getUserAccessInfo();
          if (!this.taxPlanningTerms.termsAccepted) {
            this._router.navigate(['tax-planning/terms']);
            return;
          } else if (accessInfo && accessInfo.subscriptionStatus == 'Suspended'){
            this._router.navigate(['tax-planning/manage-billing']);
            return;
          } else {
            const status: any = Session.get('user').onboardingStatus;
            if ((status && status === 'Done')  || !status) {
              this.switchBoard.onLogin.next(Session.getUser('delegatedFrom'));
              this.routePostLoginHome();
            } else if (status && status !== 'Done') {
              this._router.navigate(['tpiq/onboard']);
            }
          }
        });
      }
    }
  }

  getTpiqClientInfo(org, userId) {
    this.taxPlanningService.getTpiqClientInfo(org, userId).subscribe(response => {
      Session.put('client', response);
    }, error =>  {
    });
  }

  /**
   * Eligibility for the post-login choose-platform interstitial.
   * See in-method block comment below for the GA eligibility rule.
   */
  private shouldShowChoosePlatform(): boolean {
    // GA eligibility — projections go-live (Cary 2026-06-02, supersedes 868jtq1h0):
    // The picker shows when BOTH are true:
    //   1. environment.features.enableTaxProjections (master switch)
    //   2. The user is on a Growth-tier subscription (subscriptionPlan
    //      includes "growth", case-insensitive).
    //
    // The per-firm taxProjectionsTenantAllowlist gate was REMOVED at GA:
    // Tax Projections is now open to every Growth-tier firm (non-Growth
    // firms upgrade to unlock it). Backend tenants/app_users are pre-seeded
    // so any firm's staff resolve on handoff.
    //
    // taxProjectionsBypassTier remains as a knob but defaults FALSE
    // everywhere; flipping it true skips ONLY the Growth check, so QA on
    // dev/staging can verify the picker render without standing up a
    // Growth-tier test subscription.
    if (!this.featureFlagService.isEnabled('enableTaxProjections')) {
      return false;
    }
    if (this.featureFlagService.isEnabled('taxProjectionsBypassTier')) {
      return true;
    }
    // 868jtq1h0 follow-up: the plan name comes from the subscription-status
    // API and is captured into `Session.setUserAccessInfo({subscriptionPlan})`
    // during getUserSubscriptionAccessList(). Reading from Session.getUser()
    // would always return undefined because the /users/info endpoint does
    // not include the plan field on its DTO.
    const planLower = (Session.getUserAccessInfo()?.subscriptionPlan || '').toLowerCase();
    return planLower.includes('growth');
  }

  /**
   * Phase 1a — post-login destination router. Routes eligible users to the
   * choose-platform interstitial; otherwise emits the wallTpiqSwitch event
   * that walks the user into the legacy tax planning home.
   *
   * Called from both successful-login branches (regular login + delegated
   * login-by-token). Centralized so future rollout-rule changes (e.g.,
   * tier policy flips) only need to be made in one place.
   */
  private routePostLoginHome(): void {
    if (this.shouldShowChoosePlatform()) {
      this._router.navigate(['/choose-platform']);
      return;
    }
    const homeobj: any = {
      type: 'taxPlanningHome',
      route: 'taxPlanning',
      clearAllStates: true
    };
    setTimeout(() => {
      this.switchBoard.onWallTpiqSwitch.next(homeobj);
    });
  }
}
